import { Link } from 'react-router-dom';
import { LINE_OFFICIAL_URL } from '@/pages/gmb-audit/consult/config';

export default function SiteFooter() {
  return (
    <footer className="mt-auto w-full bg-primary-950 text-background-100">
      <div className="ds-container py-12 md:py-14">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-600 text-background-50">
                <i className="ri-store-2-line text-xl" />
              </span>
              <span className="flex flex-col leading-tight">
                <span className="text-base font-bold text-background-50">天地人網</span>
                <span className="text-sm text-primary-200">Google 商家快速健診</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/90">
              以公開 Google Maps / Places 資料為基礎，協助店家快速了解自身與附近同業的落差，找出優先改善方向。
            </p>
          </div>

          <div className="flex flex-col gap-8 sm:flex-row sm:gap-16">
            <div>
              <h4 className="text-sm font-semibold text-primary-200">產品</h4>
              <ul className="mt-3 space-y-2.5 text-sm">
                <li>
                  <Link to="/gmb-audit" className="cursor-pointer text-background-100 transition-colors hover:text-background-50">
                    快速健診
                  </Link>
                </li>
                <li>
                  <Link
                    to="/gmb-audit/methodology"
                    className="cursor-pointer text-background-100 transition-colors hover:text-background-50"
                  >
                    方法說明
                  </Link>
                </li>
                <li>
                  <Link
                    to="/gmb-audit/consult"
                    className="cursor-pointer text-background-100 transition-colors hover:text-background-50"
                  >
                    預約諮詢
                  </Link>
                </li>
                <li>
                  <a
                    href={LINE_OFFICIAL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex cursor-pointer items-center gap-1.5 text-background-100 transition-colors hover:text-background-50"
                  >
                    <i className="ri-line-fill text-base" />
                    加入 LINE 詢問
                  </a>
                </li>
              </ul>
            </div>
            <div className="max-w-xs">
              <h4 className="text-sm font-semibold text-primary-200">資料說明</h4>
              <ul className="mt-3 space-y-2.5 text-sm">
                <li className="text-background-200/90">資料來源：Google Maps / Places 公開資料</li>
                <li className="leading-relaxed text-background-200/90">
                  本工具為天地人網提供之獨立第三方服務，非 Google 官方產品，與 Google 無隸屬關係。
                </li>
                <li>
                  <Link
                    to="/gmb-audit/privacy"
                    className="cursor-pointer text-background-100 transition-colors hover:text-background-50"
                  >
                    隱私權與個資說明
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-background-50/10 pt-6">
          <p className="text-sm leading-relaxed text-background-200/80">
            © 2026 天地人網。本工具僅使用公開資料進行快速健診，不涉及 Google Business Profile 後台資料。
          </p>
        </div>
      </div>
    </footer>
  );
}